var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualtrics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652 652",
    style: {
      enableBackground: "new 0 0 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#Path_10_1_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    transform: "translate(-820.339 -532.825)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    transform: "translate(820.339 532.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M218.7,344.3c-3.7,0-4.4-2.7-4.4-7.4v-46.6c0-15.9-9-25.4-24.1-25.4c-18,0-26.2,13.8-26.3,27.5v0.6H176v-0.6 c-0.2-4.6,1.5-9.1,4.6-12.5c2.4-2.5,5.7-3.8,9.1-3.8c7.2,0,11.5,5.6,11.5,15v4.4l-14.3,6.8c-16.3,7.6-26.9,13.8-26.9,29.9 c0,14.1,8.9,23.6,22.1,23.6c8-0.2,15.4-4.1,20.2-10.5c1.5,6.3,7.2,10.7,13.7,10.5c2.6,0,5.1-0.5,7.4-1.5l0.3-0.1v-11.4l-0.8,0.4 C221.7,343.9,220.2,344.3,218.7,344.3z M201.2,307.1v27.2c-3.4,6-9.5,9.9-16.3,10.5c-6.2,0.3-11.6-4.4-11.9-10.7 c0-0.6,0-1.2,0-1.8c0-10.7,9.4-16.5,17.6-20.3L201.2,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M285.8,238.8h-12.7l-0.5,27.8H261v11.9h11.6v57.3c0,12.9,6,20,17,20c4.6-0.1,9-1.3,13-3.7l0.3-0.2v-12 l-0.9,0.7c-2.5,2.2-5.7,3.5-9.1,3.6c-5.8,0-7-4.8-7-8.9v-56.9h18.7v-11.9h-18.7V238.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M133,333.5c-5,7.2-10.7,11.2-16.1,11.2c-7.1,0-9.6-7-9.6-13.5v-64.6H94.2v65.2c0,15.2,6.9,23.9,18.8,23.9 c8-0.1,15.5-3.9,20.2-10.5l0.2,8.8H146v-87.5H133L133,333.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M65.5,274.5c-3.4-6.2-10-9.9-17-9.6c-7.6,0.1-14.7,3.9-19,10.2c-6,8.1-9.1,19.9-9.1,35.2 c0,33.5,13.5,45.5,26.2,45.5c6.8,0.2,13.2-2.8,17.3-8.2v69.5h13.2V266.6H65.9L65.5,274.5z M64,286.6v47.9 c-3.6,6.6-8,9.6-13.9,9.6c-10.8,0-16.3-11.4-16.3-33.9c0-21.6,6.2-34,16.9-34C56.9,276.5,62.3,280.7,64,286.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 234.3,
    y: 225.7,
    width: 13.1,
    height: 128.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 366.7,
    y: 266.6,
    width: 13.1,
    height: 87.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    x: 366.8,
    y: 238.7,
    width: 12.9,
    height: 15.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M330.6,276.8l-0.7-10.2h-12.4v87.7h13.1v-63.1c5.9-12,13.6-13.7,20.9-13.7l3.1,0.2V265H351 C341.7,265,336.6,267.9,330.6,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M486.6,302.1l-0.3,0.5l0,0L486.6,302.1L486.6,302.1c-8.3-4.3-14.1-7.8-14.1-15.2 c-0.2-5.7,4.3-10.5,10.1-10.7c0.4,0,0.8,0,1.2,0c3.3-0.1,6.5,1.2,8.8,3.6c2.8,3.5,4,8,3.3,12.4l-0.1,0.6h12.1l0-0.5 c0.7-7.4-1.8-14.8-6.7-20.4c-4.6-4.6-10.9-7.2-17.4-6.9c-14.1,0-23.9,9.3-23.9,22.7c0,14.6,11.7,20.8,20.2,25.4 c8.5,4.6,16.5,9,16.5,18c0.2,7.1-5.3,13-12.4,13.2c-0.3,0-0.6,0-0.9,0c-8.4,0-14.4-7-14.6-17.1v-0.5h-12.2v0.6 c0.4,17.7,10.7,28.6,26.8,28.6c13.4,0.9,24.9-9.3,25.8-22.6c0.1-0.9,0.1-1.9,0-2.8C509.2,314.1,497.1,307.7,486.6,302.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M435.6,326.6c0.1,5.2-1.6,10.3-4.9,14.4c-2,2.1-4.8,3.3-7.8,3.2c-10,0-15.4-11.7-15.4-33.9 c0-22,5.5-34.2,15.5-34.2c2.7-0.1,5.4,1,7.2,3c3,3.8,4.7,8.5,4.6,13.4h12.4c0.4-7.8-2.2-15.4-7.2-21.3 c-4.3-4.4-10.3-6.7-16.5-6.4c-18.7,0-29,16.1-29,45.5s10,45.5,28.2,45.5c14.6,0,23.8-10.8,24.9-29.1L435.6,326.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M527.7,347.1c0.3-0.5,0.4-1.1,0.4-1.7c0-0.8-0.2-1.6-0.8-2.2c-0.7-0.6-1.6-0.9-2.5-0.8h-4.7v9.3h2.3v-3.3h1.8 l1.6,3.3h2.6l-2-3.6C526.9,348,527.4,347.6,527.7,347.1z M525.4,346.4c-0.4,0.2-0.8,0.3-1.3,0.2h-1.6v-2.4h1.6 c0.4,0,0.9,0.1,1.3,0.3c0.3,0.2,0.5,0.6,0.4,1C525.8,345.8,525.7,346.2,525.4,346.4L525.4,346.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M531.6,343.7c-0.4-1-1-1.9-1.8-2.6c-0.8-0.7-1.7-1.3-2.6-1.7c-2.1-0.8-4.5-0.8-6.6,0c-1,0.4-1.9,1-2.7,1.7 c-0.8,0.7-1.4,1.6-1.8,2.6c-0.9,2.2-0.9,4.6,0,6.8c0.4,1,1,1.9,1.8,2.7c0.8,0.7,1.7,1.3,2.7,1.7c2.1,0.8,4.5,0.8,6.6,0 c1-0.4,1.9-1,2.6-1.7c0.8-0.8,1.4-1.7,1.8-2.7C532.5,348.3,532.5,345.9,531.6,343.7z M530,349.9c-0.3,0.8-0.8,1.5-1.4,2.1 c-0.6,0.6-1.3,1.1-2.1,1.4c-1.7,0.6-3.5,0.6-5.1,0c-0.8-0.3-1.5-0.8-2.1-1.4c-0.6-0.6-1.1-1.3-1.4-2.1c-0.7-1.8-0.7-3.7,0-5.5 c0.3-0.8,0.8-1.5,1.4-2.1c0.6-0.6,1.3-1.1,2.1-1.4c1.7-0.6,3.5-0.6,5.1,0c0.8,0.3,1.5,0.8,2.1,1.4c0.6,0.6,1.1,1.3,1.4,2.1 C530.7,346.2,530.7,348.1,530,349.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_10_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 863.9025,
    y1: 1254.8577,
    x2: 867.2374,
    y2: 1250.3907,
    gradientTransform: "matrix(24.608 0 0 -13.3 -19905.4121 17461.1719)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    style: {
      stopColor: "#21DBAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    style: {
      stopColor: "#00B4EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    style: {
      stopColor: "#01A7EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    style: {
      stopColor: "#0487E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#0768DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    style: {
      stopColor: "#5F1AE5"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    className: "st0",
    d: "M1424.6,771.1l-11.3,40h-0.1l-12.1-40h-26.8l-9.2,16.3l-9.7-16.3h-13.6l15.8,25.6l-17.4,28.7 h12.5l11.1-19l11.5,19h20.6v-37.7h0.1c0.3,1.6,0.6,2.9,0.8,4.1s0.5,2.2,0.7,3.1c0.2,1,0.5,1.9,0.8,2.7s0.6,1.8,0.8,2.8l8.1,24.9 h10.6l8.1-24.9c0.6-2,1.2-3.9,1.7-5.8c0.6-2.1,1-4.2,1.3-6.3h0.1v37.1h11.5v-54.4L1424.6,771.1z M1371.1,796.8l14.2-23.5v46.6 L1371.1,796.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualtrics);
export default __webpack_public_path__ + "static/media/qualtrics.df8842a755cf11eac49209b1419ce368.svg";
export { ForwardRef as ReactComponent };